import React from 'react';
import { Portal } from 'react-portal';
import GeneralNodes from "../../FAQNodes";

export default class GeneralNodesOverlay extends React.PureComponent {
  render() {
    return (
      <GeneralNodes {...this.props} />
    );
  }
}
